import React from 'react';
import PropTypes from 'prop-types';

/**
 * @param {object} props - Props.
 * @returns {JSX.Element} Component.
 */
export const TeamWatermarkBackground = ( { teamAbbreviation, className = '' } ) => (
    <div className={ `stats-team-watermark-background stats-team-watermark-background--${ teamAbbreviation.toLowerCase() } ${ className }` }>
        <div className="stats-team-watermark-background__overlay"></div>
        <div
            className="stats-team-watermark-background__watermark"
            style={{
                backgroundImage: `url('${ PULSE.app.environment.watermarksPath }${ teamAbbreviation.toLowerCase() }-right-dark.png')`
            }}
        />
    </div>
);

TeamWatermarkBackground.propTypes = {
    teamAbbreviation: PropTypes.string.isRequired,
    className: PropTypes.string
};